import axios from "axios"
import { Message } from "element-ui"
import store from "@/store"
import { getToken } from "@/utils/auth"

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 0 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.download) {
      // 下载blob文件，需要添加responseType blob
      config.responseType = "blob"
    }
    // do something before request is sent
    // Object.assign(config, paramsEncrypt(config)) // 参数加密
    const isToken = (config.headers || {}).isToken === false // 是否需要设置 token
    if (store.getters.token && !isToken) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["X-ct-sso"] = getToken()
    }
    // 自定义配置项, 按需设置
    if (config.config) {
      // token
      if (config.config.token) {
        config.headers["token"] = config.config.token
      }
    }
    // console.log("请求参数")
    // console.log(config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.config && response.config.download && response.data instanceof Blob) {
      //
      const objectUrl = URL.createObjectURL(res)
      return objectUrl
    } else {
      // if the custom code is not 20000, it is judged as an error.
      // if (res.code !== 200 || res.status === "error") {

      if ((res.code !== 200 && res.code !== "0") || res.status === "error") {
        console.log(res.message.indexOf("当前消息包含敏感词内容"))
        if (res.message == "60秒内不可发送重复内容，请稍后重试" || res.message.indexOf("当前消息包含敏感词内容") == 0) {
          Message({
            showClose: true,
            message: res.message || "Error",
            type: "error",
            duration: 8 * 1000,
            customClass: "special-msg"
          })
        } else if (res.message.indexOf("验证码匹配失败") < 0 && res.message.indexOf("登录状态已过期，请重新登录!")) {
          Message({ showClose: true, message: res.message || "Error", type: "error", duration: 5 * 1000 })
        }
        // 登录超时, 退出登录
        if (res.sign === "token_stamp_error") {
          store.dispatch("user/clearGlobal")
          location.reload()
        }
        return Promise.reject(new Error(`code:${res.code}-${res.message}` || "Error"))
      } else {
        return res
      }
    }
  },
  error => {
    console.log("拦截器响应失败")
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误(400)"
          break
        case 401:
          error.message = "未授权，请重新登录(401)，3秒后跳转！"
          break
        case 403:
          error.message = "拒绝访问(403)"
          break
        case 404:
          error.message = "请求出错(404)"
          break
        case 405:
          error.message = "没有权限访问该页面(405)"
          break
        case 408:
          error.message = "请求超时(408)"
          break
        case 500:
          error.message = "服务器错误(500)"
          break
        case 501:
          error.message = "服务未实现(501)"
          break
        case 502:
          error.message = "网络错误(502)"
          break
        case 503:
          error.message = "服务不可用(503)"
          break
        case 504:
          error.message = "网络超时(504)"
          break
        case 505:
          error.message = "HTTP版本不受支持(505)"
          break
        default:
          error.message = "连接出错" + error.response.status
      }
    } else {
      error.message = "连接服务器失败!"
    }
    console.log(111111111)
    console.log(error)
    Message({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
      showClose: true,
      onClose: function () {
        if (error.message.indexOf("401") > -1) {
          store.dispatch("user/clearGlobal")
          location.reload()
        }
      }
    })
    return Promise.reject(error)
  }
)

export default service
